<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="card-group mb-0">
                        <div class="card p-4">
                            <form @submit.prevent="login">
                                <div class="card-block">
                                    <h1>Saúde Quatro Patas</h1>
                                    <p class="text-muted">Informe suas credenciais para acessar o sistema</p>
                                    <div class="input-group mb-3" :class="{ 'has-danger': $v.user.email.$error }">
                                        <span class="input-group-addon"><i class="icon-user"></i></span>
                                        <input type="email" class="form-control" placeholder="E-mail" maxlength="100"
                                               v-model="user.email" @input="$v.user.email.$touch()">
                                    </div>
                                    <div class="input-group mb-4" :class="{ 'has-danger': $v.user.senha.$error }">
                                        <span class="input-group-addon"><i class="icon-lock"></i></span>
                                        <input type="password" class="form-control" placeholder="Senha"
                                               v-model="user.senha" @input="$v.user.senha.$touch()">
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <button type="submit" class="btn btn-primary px-4">Entrar</button>
                                        </div>
                                        <div class="col-6 text-right">
                                            <button type="button" @click="forgotPassword()" class="btn btn-link px-0" style="cursor: pointer">Esqueci minha senha</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="card card-inverse py-5 d-md-down-none" style="width:44%">
                            <div class="card-block text-center">
                                <div>
                                    <br><br><br>
                                    <img src="/static/images/logo.png" alt="Dowhile" width="240">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {required, minLength, email} from 'vuelidate/lib/validators';
    import Facade from '../../facade/facade';
    const facade = new Facade();

    export default {
        name: 'Login',
        data() {
            return {
                user: {
                    email: '',
                    senha: ''
                }
            }
        },
        validations() {
            const vm = this
            return {
                user: {
                    email: {
                        required,
                        email,
                        minLength: minLength(5)
                    },
                    senha: {
                        required,
                        minLength: minLength(5)
                    }
                }
            };
        },
        methods: {
            login() {
                let vm = this;
                if (this.$v.user.$invalid) {
                    this.$notify.warning('Atenção!', 'Verifique se todos os campos estão preenchidos corretamente.');
                    return;
                }

                this.$loading.show(true);
                let ret = facade.login(this.user);
                ret.then(user => {
                    vm.$router.push({name: 'home'});
                    vm.$loading.show(false);
                }).catch(e => {
                    e.forEach((item) => {
                        this.$notify.error(item.field, item.message);
                    });
                    this.$loading.show(false);
                });
            },
            forgotPassword() {
                this.$router.push({name: 'forgot-password'});
            }
        },
        created () {
            if (facade.isLoggedIn()) {
                this.$router.push({name: 'home'});
            }
        },
    }
</script>



// WEBPACK FOOTER //
// Login.vue?8a5e4556